/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Badge_CommunityInputs */

const en_pb_badge_community = /** @type {(inputs: Pb_Badge_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`community`)
};

const id_pb_badge_community = /** @type {(inputs: Pb_Badge_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`komunitas`)
};

/**
* | output |
* | --- |
* | "community" |
*
* @param {Pb_Badge_CommunityInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_badge_community = /** @type {((inputs?: Pb_Badge_CommunityInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Badge_CommunityInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_badge_community(inputs)
	return en_pb_badge_community(inputs)
});